// src/hooks/useAddons.js
// Paid AI add-ons of this shop — all OFF unless the platform owner switched them on:
//   ai_analysis 🩺 Health Check · ai_scan 📷 invoice scan · ai_chat 💬 AI assistant
// The server enforces them too; this only decides what to show.
import { useQuery } from '@tanstack/react-query';
import api from '../config/api';

const OFF = { ai_analysis: false, ai_scan: false, ai_chat: false };

export default function useAddons() {
  const { data } = useQuery({
    queryKey: ['ai-addons'],
    queryFn: () => api.get('/api/analysis/access').then((r) => ({ ...OFF, ...(r.data || {}) })).catch(() => OFF),
    staleTime: 10 * 60 * 1000,
  });
  return data || OFF;
}
